import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface ToastConfig {
  title: string;
  body: string;
  type: 'success' | 'warning' | 'danger' | 'info';
  items?: string[]; // Optional array of strings will be put into a bulleted list under the body message
  durationSeconds?: number; // Optional auto-dismiss delay in seconds; omit to use the default behavior for the toast type
}

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private toasts = new Subject<ToastConfig>();
  toasts$ = this.toasts.asObservable();

  public success(message: string, items?: string[]): void {
    this.showToast('Success', message, 'success', items);
  }

  public error(message: string, items?: string[], durationSeconds?: number): void {
    this.showToast('Error', message, 'danger', items, durationSeconds);
  }

  public reminder(message: string, items?: string[]): void {
    this.showToast('Reminder', message, 'danger', items);
  }

  public warn(message: string, items?: string[]): void {
    this.showToast('Warning', message, 'warning', items);
  }

  public info(message: string, items?: string[]): void {
    this.showToast('Information', message, 'info', items);
  }

  private showToast(
    title: string,
    message: string,
    type: 'success' | 'warning' | 'danger' | 'info',
    items?: string[],
    durationSeconds?: number,
  ): void {
    const toast: ToastConfig = {
      title,
      body: message,
      type,
      items: items || undefined,
      durationSeconds: durationSeconds ?? 2.5,
    };

    this.toasts.next(toast);
  }
}
